module.exports = __webpack_public_path__ + "img/lessoncard-button-background.ac16fbb1.svg";